import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Home from "./Components/Dashboard/Home";
import AllEvents from "./Components/Dashboard/AllEvents";
import EventDetail from "./Components/Dashboard/EventDetail";
import Cart from "./Components/Dashboard/Cart";
import TicketDetail from "./Components/Dashboard/TicketDetails";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/events" element={<AllEvents />} />
      <Route path="/event/:id" element={<EventDetail />} />
      <Route path="/cart/:id" element={<Cart />} />
      <Route path="/tickets" element={<TicketDetail />} />
      <Route path="/*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default AppRoutes;
